import { defineStore } from "pinia"
import { ref } from "vue"

type Logos = {
  logoUrl: string
  brandUrl: string
}

export const useLogosStore = defineStore("logos", () => {
  const logos: Ref<Logos> = ref({
    logoUrl: '',
    brandUrl: '',
  });

  const runtimeConfig = useRuntimeConfig();

  async function fetchLogos () {
    const response: any = await $fetch(`${runtimeConfig.public.api_host}api/logo`);
    return logos.value = {
      logoUrl: runtimeConfig.public.storage_host + response.logo[0].image_url,
      brandUrl: runtimeConfig.public.storage_host + response.brand.image_url,
    };
  }

  return {
    logos,
    fetchLogos,
  }
})
